let initialState = {
    nextPage: '',
    prePage: []
};

const navigationReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ADD-NEXT-PAGE':
            state = {
                ...state,
                nextPage: action.payload,
                prePage: [...state.prePage, state.nextPage]
            }
            break;
        case 'CLEAR-NEXT-PAGE':
            state = initialState
            break
        default:
            return state;
    };

    return state;
}

export default navigationReducer;